<template>
  <v-layout row wrap pa-3>
    <v-flex xs12 md9 wrap>
      <v-layout column main-section>
        <v-flex pt-3>
          <!-- <v-card-title>
              <h3 class="halfwhite-text">
                {{ $store.getters.getHeadingForBalanceBlock }}
              </h3>
              <h3 class="section-title halfwhite-text text-uppercase">
                Manage Team
              </h3>
            </v-card-title> -->
          <MembersList v-if="$store.getters.isCurrentOrgSet"></MembersList>
          <v-flex v-else>
            <v-card>
              <v-card-text>
                <div>
                  There is no active org available in your user profile, please
                  create a new org or switch to an existing org.
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md3 px-3 mt-2>
      <v-layout column wrap>
        <DashboardSidebar></DashboardSidebar>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import MembersList from "@/components/MembersList";
//import BalanceColumn from "@/components/BalanceColumn";
import DashboardSidebar from "@/components/DashboardSidebar";

export default {
  name: "TeamMembers",
  components: { MembersList, DashboardSidebar },
  computed: {},
};
</script>
